import styled from 'styled-components';

export const TableFooter = styled.tfoot({});
